import { atom } from "recoil"

export const meshIsValidState = atom<boolean>({
  key: `meshIsValid`,
  default: true,
})
